import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { SelectInterface } from '@ionic/core';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'mom-form-field-select',
  templateUrl: './form-field-select.component.html',
  styleUrls: ['./form-field-select.component.scss']
})
export class FormFieldSelectComponent {
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() options: Option<unknown>[];
  @Input() required: boolean;
  @Input() multiple: boolean;
  @Input() placeholder: string;

  interface: SelectInterface;

  constructor() {
    this.interface = Capacitor.getPlatform() === 'web' ? 'popover' : 'alert';
  }

}
